import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullPage = false, size = 'medium' }) => {
  const sizeClasses = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large',
  };

  if (fullPage) {
    return (
      <div className="full-page-spinner">
        <div className={`spinner ${sizeClasses[size] || sizeClasses.medium}`}></div>
      </div>
    );
  }

  return <div className={`spinner ${sizeClasses[size] || sizeClasses.medium}`}></div>;
};

export default LoadingSpinner;
